import { MediaPlayerProps } from './MediaPlayer';

export * from './MediaVideo';
export type MediaVideoProps = MediaPlayerProps;
